import React, { Component } from "react";
import { Checkbox, Dropdown } from "antd";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import "styles/SelectFilter.scss";
const CheckboxGroup = Checkbox.Group;

export default class UniFilter extends Component {
  state = {
    expanded: false,
  };

  renderInstOptions = () => {
    const { institutions } = this.props;
    const instOptions = Object.keys(institutions)
      .sort((a, b) =>
        institutions[a].name.toLowerCase() < institutions[b].name.toLowerCase()
          ? -1
          : 1
      )
      .map((abbr) => (
        <Checkbox key={abbr} value={abbr} className="select-filter-checkbox">
          <div className="indented">{institutions[abbr].name}</div>
        </Checkbox>
      ));
    return instOptions;
  };

  openDropdown = (event) => {
    event.preventDefault();
    this.setState({ expanded: true }, () => {
      document.addEventListener("click", this.closeDropdown);
    });
  };

  closeDropdown = (event) => {
    if (!this.dropdown || !this.state.expanded) {
      return;
    }
    if (!this.dropdown.contains(event.target)) {
      this.setState({ expanded: false }, () => {
        document.removeEventListener("click", this.closeDropdown);
      });
    }
  };

  render() {
    const { selected } = this.props;
    return (
      <Dropdown
        className="select-filter-container desktop-and-tablet"
        overlay={
          <div
            className="select-filter-content"
            ref={(element) => {
              this.dropdown = element;
            }}
          >
            <CheckboxGroup
              onChange={this.props.onChange}
              value={this.props.selected}
              className="filter-checkbox-group"
            >
              {this.renderInstOptions()}
            </CheckboxGroup>
          </div>
        }
        trigger={["click"]}
        // open={this.state.expanded}
        placement="bottom"
      >
        <div
          className="select-filter-button"
          onClick={this.state.expanded ? this.closeDropdown : this.openDropdown}
        >
          <span className="select-filter-title">
            Universities
            {selected.length > 0 && (
              <div className="number-selected-tag">{selected.length}</div>
            )}
          </span>
          {this.state.expanded ? (
            <UpOutlined
              style={{ fontSize: "16px" }}
              className="uni-filter-icon"
            />
          ) : (
            <DownOutlined
              style={{ fontSize: "16px" }}
              className="uni-filter-icon"
            />
          )}
        </div>
      </Dropdown>
    );
  }
}
